import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 样式
import '@/assets/css/index.scss'
import 'animate.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 兼容改造前的 hash 链接（如 /#/hardware/slygt）：重定向到 History 路径，且不再挂载应用
const legacyHash = window.location.hash
if (legacyHash.startsWith('#/')) {
  window.location.replace(window.location.origin + legacyHash.slice(1))
} else {
  new Vue({
    router: router,
    render: h => h(App),
  }).$mount('#app')
}
